import React from 'react';
import Hero from '../../components/home/Hero';
import Missions from '../../components/home/Missions';
import About from '../../components/home/About';
import Banner from '../../components/home/Banner';
import GetInvolved from '../../components/home/GetInvolved';
import FollowUs from '../../components/home/FollowUs';

function Home() {
  return (
    <>
      <Hero />
      <Missions />
      <About />
      <Banner />
      <GetInvolved />
      <FollowUs />
    </>
  );
}

export default Home;
